/** Colunas do order by das entidades na consulta da Curva ABC de Vendas */
export enum CurvaAbcVendaEntityOrderBy {
    CodigoIntegracaoErp = 1,
    Nome = 2,
    Quantidade = 3,
    QuantidadeConvertida = 4,
    Peso = 5,
    ValorTotal = 6,
    PrecoMedio = 7,
    PrecoMedioConvertido = 8,
    PercParticipacao = 9,
    QuantidadeMedia = 10,
    QuantidadeConvertidaMedia = 11,
    PesoMedio = 12,
    ValorMedio = 13
};
